<template>
<div>
  <search-list
    :projectList = "projectList"
    :leaseTimeeEnums = "leaseTimeeEnums"
    :surrenderStatuseEnums = "surrenderStatuseEnums"
    :surTypeEnums = "surTypeEnums"
    @findData="findData"
    :surModeEnums="surModeEnums"
    :surrenderAuditTypeEnum="surrenderAuditTypeEnum"
  >
  </search-list>
  <div class="page-wrapper">
  <table-list
      :columns="columns"
      :defaultColumns ="defaultColumns"
      :data="tableData"
      :total="total"
      :current="current"
      :loading="loading"
      @change-page="changePage"
    >
  </table-list>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { getConditions,surrenderList } from 'api/termination'
import {getProjects } from 'api/common'
import SearchList from './components/SearchList'
// import TableList from 'components/TableList/index';
import TableList from "components/FilterTableList/index";

export default {
  name:'audittermination',
  components:{
    SearchList,
    TableList
  },
  watch: {
    $route(to, from) {
     if((from.name=='personalterminationdetail' || from.name == 'companyterminationdetail') && from.query.isAudit==1){
      this.findData(this.searchData)
     }
    }
  },
  data () {
    return {
      surModeEnums:[],
      surrenderAuditTypeEnum:[],
      loading:true, // true
      total:0,
      current:1,
      closeKey:0,
      closeSurrenderFid:'',
      searchData:{
        projectFid:'',
        surType:'',
        surStatus:'',
        leaseTime:'',
        surReleaseStartDate:'',
        surReleaseEndDate:'',
        surApplicationStartDate:'',
        surApplicationEndDate:'',
        contractCode:null,
        surCode:null,
        customerName:null,
        userPhone:null,
        stockFid:null,
        handleZo:null,
        limit: 10,
        page: 1,
        surAuditType:2
      },
      leaseTimeeEnums:[], // 出租类型
      surrenderStatuseEnums:[], // 解约协议状态
      surTypeEnums:[], // 解约类型
      projectList:[],
      columns:[
        {
        type:'index',
        width:60,
        align:'center'
        },

        {
          title:'项目',
          key:'projectName',
          align:'center',
          width:160
        },


        {
          title:'房间/床位号',
          key:'stockNumber',
          align:'center',
          width:120
        },

        {
          title:'解约类型',
          key:'surTypeName',
          align:'center',
          width:100
        },

        {
          title:'解约方式',
          key:'surModeName',
          align:'center',
          width:120,
        },

        {
          title:'审核类型',
          key:'surAuditTypeName',
          align:'center',
          width:120,
        },

        {
          title:'解约客户',
          key:'customerName',
          align:'center',
          width:220
        },

        {
          title:'解约日期',
          key:'surReleaseDate',
          align:'center',
          width:120
        },

        {
          title:'结算金额',
          key:'costAmount',
          align:'center',
          width:120,
          render:(h,params) =>{
            let costAmount = Number(params.row.costAmount).toFixed(2);
            return h('div',{
              style:{
                'text-align':'right'
              }
            },Number(costAmount).toLocaleString())
          }
        },

        {
          title:'解约协议状态',
          key:'surStatusName',
          align:'center',
          width:120
        },

        {
          title:'审核人',
          key:'surAuditZo',
          align:'center',
          width:80
        },

        {
          title:'审核日期',
          key:'surAuditDate',
          align:'center',
          width:120
        },

        {
          title:'解约ZO',
          key:'handleZo',
          align:'center',
          width:120
        },

        {
          title:'解约协议编号',
          key:'surCode',
          align:'center',
          width:180,
          render:(h,params) => {
            return h('a',{
              on:{
                click: ()=>{
                  if (params.row.subjectType === 1){
                    this.$router.push({
                      name: 'personalterminationdetail',
                      query:{
                        surrenderFid: params.row.surFid,
                        contractFid:params.row.contractFid
                      }
                    })
                  }else if (params.row.subjectType === 3){
                    this.$router.push({
                    name: 'companyterminationdetail',
                    query:{
                      isaudit:0,
                      surrenderFid: params.row.surFid,
                      parentSurrenderFid: params.row.parentSurrenderFid,
                      contractFid:params.row.contractFid
                    }
                  })
                  }
                }
              }
            },params.row.surCode)
          }
        },

        {
          title:'客户手机号',
          key:'surCustomerPhone',
          align:'center',
          width:120
        },

        {
          title:'解约申请日期',
          key:'surApplicationdate',
          align:'center',
           width:120
        },

        {
          title:'操作',
          key:'action',
          align:'center',
          fixed:'right',
          width:100,
          render: (h,params) =>{
            return h('a', {
              directives:[
                {
                  name:'p',
                  value:{
                    api:'surrender/confirmSurrAudit'
                  }
                }
              ],
              style: {
                marginRight: '5px',
                display: params.row.surStatus === 0 || params.row.surStatus === 1 ? 'inline-block' : 'none'
              },
              on: {
                click: () => {
                  if (params.row.subjectType === 1) {
                    this.$router.push({
                      name: 'personalterminationdetail',
                      query: {
                        isAudit: 1,
                        surrenderFid: params.row.surFid,
                        // parentSurrenderFid: params.row.parentSurrenderFid,
                        contractFid: params.row.contractFid
                      }
                    })
                  } else if (params.row.subjectType === 3) {
                    this.$router.push({
                      name: 'companyterminationdetail',
                      query: {
                        isAudit: 1,
                        surrenderFid: params.row.surFid,
                        parentSurrenderFid: params.row.parentSurrenderFid,
                        contractFid: params.row.contractFid
                      }
                    })
                  }
                }
              }
            }, '审核')
          }
        }
      ],
      defaultColumns:['surModeName','projectName','stockNumber', 'surAuditTypeName','surTypeName', 'customerName', 'surReleaseDate', 'costAmount', 'surStatusName', 'surAuditZo', 'surAuditDate','handleZo','action' ],
      tableData:[]
    };
  },
  created(){
    this.initData()
  },
  methods:{
   changePage(n){
      this.loading  = true;
      this.current = n;
      this.searchData.page = n;
      this.getList(this.searchData)
    },
    initData(){
      getProjects().then( res => {
        this.projectList = res.data;
        if(this.projectList && this.projectList.length > 0){
          this.searchData.projectFid = this.projectList[0].value
        }
        this.getList(this.searchData)
      });
      getConditions().then( res => {
        this.leaseTimeeEnums = res.data.leaseTimeeEnums;
        this.surrenderStatuseEnums = res.data.surrenderStatuseEnums;
        this.surTypeEnums = res.data.surTypeEnums

        this.surModeEnums=res.data.surModeEnums
        this.surrenderAuditTypeEnum = res.data.surrenderAuditTypeEnum
      });
    },
   findData(data){
     this.current = 1;
     this.searchData = data;
     this.searchData.page = 1;
     this.getList(this.searchData)
   },
   getList(data){
     this.loading = true;
     surrenderList(data).then(res => {
      this.tableData = res.data.rows;
      this.total = res.data.total;
      this.loading = false
     })
   }
 }
}
</script>
